import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ProductGroupIntegrationListComponent } from '../../../shared/components/product-group-integration-list/product-group-integration-list.component';
import { FormlyFillHeightListHostDirective } from '../formly-tabs/formly-fill-height-list-host.directive';

@Component({
    selector: 'app-formly-product-group-integration-link-list',
    templateUrl: './formly-product-group-integration-link-list.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [FormlyFillHeightListHostDirective],
    imports: [CommonModule, ProductGroupIntegrationListComponent],
})
export class FormlyProductGroupIntegrationLinkListComponent extends FieldType {
}
